export default __webpack_public_path__ + "static/media/kashlok.10c02a76.svg";